export const USER_FORM_INITIAL_VALUES = {
  avatarId: null,
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  role: '',
  password: '',
  passwordConfirmation: '',
};
